module.exports = __webpack_public_path__ + "static/media/humidity.74e7cb3c.svg";